import { LoginEnabledLocale } from '@youversion/types';

export const fallbackLng = 'en-US';

export const authLanguages = [
  'af-ZA',
  'id-ID',
  'ms-MY',
  'ca-ES',
  'cs-CZ',
  'cy-GB',
  'da-DK',
  'de-DE',
  'en-GB',
  'es-LA', // es defaults to es-LA so it must be before es-ES
  'es-ES',
  'fr-FR',
  'hr-HR',
  'it-IT',
  'km-KH',
  'lv-LV',
  'hu-HU',
  'nl-NL',
  'no-NO',
  'pl-PL',
  'pt-BR', // pt defaults to pt-BR so it must be before pt-PT
  'pt-PT',
  'ro-RO',
  'sq-AL',
  'sk-SK',
  'fi-FI',
  'sv-SE',
  'vi-VN',
  'tr-TR',
  'el-GR',
  'hi-IN',
  'be-BY',
  'bg-BG',
  'mk-MK',
  'ru-RU',
  'uk-UA',
  'fa-IR',
  'ta-IN',
  'th-TH',
  'my-MM',
  'ko-KR',
  'zh-CN', // zh defaults to zh-CN so it must be before zh-TW and zh-HK
  'zh-TW',
  'ja-JP',
  'zh-HK',
] satisfies Array<LoginEnabledLocale>;

export const languages = [fallbackLng, ...authLanguages, 'ar', 'he', 'my', 'sw', 'tl-PH', 'xc-MN'] satisfies Array<
  LoginEnabledLocale | 'ar' | 'he' | 'my' | 'sw' | 'tl-PH' | 'xc-MN'
>;
